import { render, staticRenderFns } from "./thermal.vue?vue&type=template&id=40e790c2&scoped=true&"
import script from "./thermal.vue?vue&type=script&lang=js&"
export * from "./thermal.vue?vue&type=script&lang=js&"
import style0 from "./thermal.vue?vue&type=style&index=0&id=40e790c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e790c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e790c2')) {
      api.createRecord('40e790c2', component.options)
    } else {
      api.reload('40e790c2', component.options)
    }
    module.hot.accept("./thermal.vue?vue&type=template&id=40e790c2&scoped=true&", function () {
      api.rerender('40e790c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/thermal.vue"
export default component.exports